import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var PresentSVG = function PresentSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M14,24.5a1.494,1.494,0,0,1-1.172-.563l-4-5a1.5,1.5,0,1,1,2.342-1.874l4,5A1.5,1.5,0,0,1,14,24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M16,19.5a1.5,1.5,0,0,1-1.2-.6l-3-4a1.5,1.5,0,1,1,2.4-1.8l3,4A1.5,1.5,0,0,1,16,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M32,24.5a1.494,1.494,0,0,1-1.172-.563l-4-5a1.5,1.5,0,0,1,2.342-1.874l4,5A1.5,1.5,0,0,1,32,24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M34,19.5a1.5,1.5,0,0,1-1.2-.6l-3-4a1.5,1.5,0,1,1,2.4-1.8l3,4A1.5,1.5,0,0,1,34,19.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M9,25V37a3.881,3.881,0,0,0,3.75,4h22.5A3.881,3.881,0,0,0,39,37V25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__no-fill",
    x: "7.43",
    y: "13.71",
    width: "10.93",
    height: "7.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M20.44,11.29H15.93a2.43,2.43,0,0,1,0-4.86,2.385,2.385,0,0,1,1.8.8A15.929,15.929,0,0,1,20.44,11.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M30.5,8.86a2.433,2.433,0,0,1-2.43,2.43H23.56a15.929,15.929,0,0,1,2.71-4.06,2.385,2.385,0,0,1,1.8-.8A2.433,2.433,0,0,1,30.5,8.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M18.36,23.43V35.57H11.07a1.208,1.208,0,0,1-1.21-1.21V23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M34.14,23.43V34.36a1.208,1.208,0,0,1-1.21,1.21H25.64V23.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__no-fill",
    x: "25.64",
    y: "13.71",
    width: "10.93",
    height: "7.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "DetailedIcon__accent-color-fill",
    x: "20.79",
    y: "13.71",
    width: "2.42",
    height: "21.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M37.79,11.29H32.25a4.8,4.8,0,0,0,.68-2.43A4.865,4.865,0,0,0,28.07,4a4.8,4.8,0,0,0-3.62,1.63A20.45,20.45,0,0,0,22,9.01a20.45,20.45,0,0,0-2.45-3.38A4.8,4.8,0,0,0,15.93,4a4.865,4.865,0,0,0-4.86,4.86,4.8,4.8,0,0,0,.68,2.43H6.21A1.208,1.208,0,0,0,5,12.5v9.71a1.21,1.21,0,0,0,1.21,1.22H7.43V34.36A3.64,3.64,0,0,0,11.07,38H32.93a3.64,3.64,0,0,0,3.64-3.64V23.43h1.22A1.21,1.21,0,0,0,39,22.21V12.5A1.208,1.208,0,0,0,37.79,11.29ZM23.21,35.57H20.79V13.71h2.42ZM15.93,6.43a2.385,2.385,0,0,1,1.8.8,15.929,15.929,0,0,1,2.71,4.06H15.93a2.43,2.43,0,0,1,0-4.86Zm2.43,29.14H11.07a1.208,1.208,0,0,1-1.21-1.21V23.43h8.5Zm0-14.57H7.43V13.71H18.36Zm5.2-9.71a15.929,15.929,0,0,1,2.71-4.06,2.385,2.385,0,0,1,1.8-.8,2.43,2.43,0,0,1,0,4.86ZM34.14,34.36a1.208,1.208,0,0,1-1.21,1.21H25.64V23.43h8.5ZM36.57,21H25.64V13.71H36.57Z"
  }));
};
PresentSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
PresentSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Present")
};
export default withDetailedIcon(PresentSVG);